// extracted by mini-css-extract-plugin
export default {"supportDetailsContainer":"SupportDetails_supportDetailsContainer__p2s8q","heading":"SupportDetails_heading__jYEvb"};